<template>
  <div id="canvas" class="h-100">
    <div @click.stop class="bmc-toolbar" :style="{'background-color': color || '#F56991'}">
      <div class="bmc-toolbar__title">
        <button class="hide-print mdc-icon-button material-icons" @click="onClickOnNav()">menu</button>
        <h2>{{name}}</h2>
      </div>
      <div class="bmc-toolbar__buttons hide-print">
        <button
          class="hide-print mdc-icon-button material-icons"
          @click="onClickOnEditColor()"
        >color_lens</button>
        <button class="hide-print mdc-icon-button material-icons" @click="onClickOnEditTitle()">edit</button>
        <button
          class="mdc-icon-button material-icons"
          @click="onClickOnDownloadCanvas()"
        >cloud_download</button>
        <button class="mdc-icon-button material-icons" @click="onClickOnDeleteCanvas()">delete</button>
      </div>
    </div>
    <div class="bmc-canvas">
      <div class="bmc-canvas__top">
        <div class="bmc-canvas__item bmc-canvas__partnership">
          <CanvasItem
            :buttonBackgroundColor="color"
            @onClickOnHelp="onClickOnHelp('key-partners')"
            @created="label => onItemCreated('key-partners', label)"
            @deleted="index => onItemDeleted('key-partners', index)"
            :items="items['key-partners']"
            label="Key partners"
            icon="all_inclusive"
          ></CanvasItem>
        </div>
        <div class="bmc-canvas__item bmc-canvas__activities">
          <CanvasItem
            :buttonBackgroundColor="color"
            @onClickOnHelp="onClickOnHelp('key-activities')"
            @created="label => onItemCreated('key-activities', label)"
            @deleted="index => onItemDeleted('key-activities', index)"
            :items="items['key-activities']"
            label="Key activities"
            icon="golf_course"
          ></CanvasItem>
        </div>
        <div class="bmc-canvas__item bmc-canvas__resources">
          <CanvasItem
            :buttonBackgroundColor="color"
            @onClickOnHelp="onClickOnHelp('key-resources')"
            @created="label => onItemCreated('key-resources', label)"
            @deleted="index => onItemDeleted('key-resources', index)"
            :items="items['key-resources']"
            label="Key resources"
            icon="location_city"
          ></CanvasItem>
        </div>
        <div class="bmc-canvas__item bmc-canvas__value">
          <CanvasItem
            :buttonBackgroundColor="color"
            @onClickOnHelp="onClickOnHelp('value-propositions')"
            @created="label => onItemCreated('value-propositions', label)"
            @deleted="index => onItemDeleted('value-propositions', index)"
            :items="items['value-propositions']"
            label="Value propositions"
            icon="cake"
          ></CanvasItem>
        </div>
        <div class="bmc-canvas__item bmc-canvas__customer-relations">
          <CanvasItem
            :buttonBackgroundColor="color"
            @onClickOnHelp="onClickOnHelp('customer-relationships')"
            @created="label => onItemCreated('customer-relationships', label)"
            @deleted="index => onItemDeleted('customer-relationships', index)"
            :items="items['customer-relationships']"
            label="Customer relationships"
            icon="group"
          ></CanvasItem>
        </div>
        <div class="bmc-canvas__item bmc-canvas__channels">
          <CanvasItem
            :buttonBackgroundColor="color"
            @onClickOnHelp="onClickOnHelp('channels')"
            @created="label => onItemCreated('channels', label)"
            @deleted="index => onItemDeleted('channels', index)"
            :items="items['channels']"
            label="Channels"
            icon="wifi_tethering"
          ></CanvasItem>
        </div>
        <div class="bmc-canvas__item bmc-canvas__customer-segments">
          <CanvasItem
            :buttonBackgroundColor="color"
            @onClickOnHelp="onClickOnHelp('customer-segments')"
            @created="label => onItemCreated('customer-segments', label)"
            @deleted="index => onItemDeleted('customer-segments', index)"
            :items="items['customer-segments']"
            label="Customer segments"
            icon="list_alt"
          ></CanvasItem>
        </div>
      </div>
      <div class="bmc-canvas__bottom">
        <div class="bmc-canvas__item bmc-canvas__costs">
          <CanvasItem
            :buttonBackgroundColor="color"
            @onClickOnHelp="onClickOnHelp('cost-structure')"
            @created="label => onItemCreated('cost-structure', label)"
            @deleted="index => onItemDeleted('cost-structure', index)"
            :items="items['cost-structure']"
            label="Cost structure"
            icon="money_off"
          ></CanvasItem>
        </div>
        <div class="bmc-canvas__item bmc-canvas__incomes">
          <CanvasItem
            :buttonBackgroundColor="color"
            @onClickOnHelp="onClickOnHelp('revenue-streams')"
            @created="label => onItemCreated('revenue-streams', label)"
            @deleted="index => onItemDeleted('revenue-streams', index)"
            :items="items['revenue-streams']"
            label="Revenue streams"
            icon="attach_money"
          ></CanvasItem>
        </div>
      </div>
    </div>
    <div
      @click.stop
      class="mdc-dialog"
      id="canvas-title-edit-dialog"
      role="alertdialog"
      aria-modal="true"
      aria-labelledby="my-dialog-title"
      aria-describedby="my-dialog-content"
      @keyup.enter="onClickOnSubmitEditTitle()"
    >
      <div class="mdc-dialog__container">
        <div class="mdc-dialog__surface">
          <h2 class="mdc-dialog__title" id="my-dialog-title">Edit title</h2>
          <div class="mdc-dialog__content" id="my-dialog-content">
            <Input v-model="editTitleModel" label="Title"></Input>
          </div>
          <footer class="mdc-dialog__actions">
            <button
              type="button"
              class="mdc-button mdc-dialog__button"
              data-mdc-dialog-action="close"
            >
              <span class="mdc-button__label">Cancel</span>
            </button>
            <button
              @click="onClickOnSubmitEditTitle()"
              type="button"
              class="mdc-button mdc-button--raised mdc-dialog__button"
            >
              <span class="mdc-button__label">Save</span>
            </button>
          </footer>
        </div>
      </div>
      <div class="mdc-dialog__scrim"></div>
    </div>
    <div
      @click.stop
      class="mdc-dialog"
      id="canvas-color-edit-dialog"
      role="alertdialog"
      aria-modal="true"
      aria-labelledby="my-dialog-title"
      aria-describedby="my-dialog-content"
      @keyup.enter="onClickOnSubmitEditColor()"
    >
      <div class="mdc-dialog__container">
        <div class="mdc-dialog__surface">
          <h2 class="mdc-dialog__title" id="my-dialog-title">Edit color</h2>
          <div class="mdc-dialog__content" id="my-dialog-content">
            <p>
              Use the color picker or insert
              <br />the HEX code below
            </p>
            <p>
              <input type="color" v-model="editColorModel" />
            </p>
            <Input v-model="editColorModel" label="Color"></Input>
          </div>
          <footer class="mdc-dialog__actions">
            <button
              type="button"
              class="mdc-button mdc-dialog__button"
              data-mdc-dialog-action="close"
            >
              <span class="mdc-button__label">Cancel</span>
            </button>
            <button
              @click="onClickOnSubmitEditColor()"
              type="button"
              class="mdc-button mdc-button--raised mdc-dialog__button"
            >
              <span class="mdc-button__label">Save</span>
            </button>
          </footer>
        </div>
      </div>
      <div class="mdc-dialog__scrim"></div>
    </div>
    <div
      @click.stop
      class="mdc-dialog"
      id="canvas-delete-confirm-dialog"
      role="alertdialog"
      aria-modal="true"
      aria-labelledby="my-dialog-title"
      aria-describedby="my-dialog-content"
    >
      <div class="mdc-dialog__container">
        <div class="mdc-dialog__surface">
          <h2 class="mdc-dialog__title" id="my-dialog-title">Are you sure?</h2>
          <div class="mdc-dialog__content" id="my-dialog-content">
            <p>Are you sure you want to delete the canvas?</p>
          </div>
          <footer class="mdc-dialog__actions">
            <button
              type="button"
              class="mdc-button mdc-dialog__button"
              data-mdc-dialog-action="close"
            >
              <span class="mdc-button__label">Cancel</span>
            </button>
            <button
              @click="onClickOnConfirmDeleteCanvas()"
              type="button"
              class="mdc-button mdc-button--raised mdc-dialog__button"
            >
              <span class="mdc-button__label">Delete</span>
            </button>
          </footer>
        </div>
      </div>
      <div class="mdc-dialog__scrim"></div>
    </div>
  </div>
</template>

<script>
import CanvasItem from "./CanvasItem.vue";
import { MDCDialog } from "@material/dialog";
import Input from "./Input.vue";
import { AnalyticsService } from "../services/AnalyticsService.js";
import { PdfExportService } from "../services/PdfExportService.js";

export default {
  name: "bmcanvas",
  props: ["name", "items", "id", "color"],
  data() {
    return {
      dialog: null,
      deleteConfirmDialog: null,
      editTitleModel: this.name,
      editColorModel: this.color || '#F56991'
    };
  },
  mounted() {
    this.dialog = new MDCDialog(
      this.$el.querySelector("#canvas-title-edit-dialog")
    );
    this.colorDialog = new MDCDialog(
      this.$el.querySelector("#canvas-color-edit-dialog")
    );
    this.deleteConfirmDialog = new MDCDialog(
      this.$el.querySelector("#canvas-delete-confirm-dialog")
    );
  },
  methods: {
    onClickOnNav(e) {
      this.$emit("onClickOnNav");
    },
    onItemCreated(group, label) {
      this.$emit("onItemCreated", group, label);
    },
    onItemDeleted(group, index) {
      this.$emit("onItemDeleted", group, index);
    },
    onClickOnEditColor() {
      this.editColorModel = this.color || '#F56991';
      this.colorDialog.open();
    },
    onClickOnEditTitle() {
      this.editTitleModel = this.name;
      this.dialog.open();
    },
    onClickOnSubmitEditTitle() {
      this.dialog.close();
      this.$emit("onTitleEdited", this.editTitleModel);
    },
    onClickOnSubmitEditColor() {
      this.colorDialog.close();
      this.$emit("onColorEdited", this.editColorModel);
    },
    onClickOnDeleteCanvas() {
      this.deleteConfirmDialog.open();
    },
    onClickOnConfirmDeleteCanvas() {
      this.deleteConfirmDialog.close();
      this.$emit("onCanvasDeleted");
    },
    onClickOnHelp(item) {
      this.$emit("onClickOnHelp", item);
    },
    onClickOnDownloadCanvas() {
      AnalyticsService.onClickOnExport();
      const canvasClone = document.getElementById("canvas").cloneNode(true);
      canvasClone.querySelectorAll("button").forEach(el => el.remove());
      canvasClone
        .querySelectorAll(".info-icon")
        .forEach(el => (el.style.color = "#fff"));
      PdfExportService.exportElement(canvasClone);
    }
  },
  components: {
    CanvasItem,
    Input
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.bmc-toolbar {
  padding: 0 20px;
  color: #fff;
  height: 60px;
  display: flex;
  justify-content: space-between;
  display: flex;
  align-items: center;
  .bmc-toolbar__title {
    display: flex;
    align-items: center;
    overflow: hidden;
    h2 {
      white-space: nowrap;
      text-overflow: ellipsis;
    }
    button {
      margin-right: 20px;
    }
  }
  .bmc-toolbar__buttons {
    white-space: nowrap;
  }
}
.bmc-canvas {
  height: calc(100% - 60px);
  .bmc-canvas__top {
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    grid-template-rows: 3fr 3fr;
    height: 70%;
  }
  .bmc-canvas__bottom {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    height: 30%;
  }
  .bmc-canvas__item {
    position: relative;
    border: 1px solid #ddd;
  }
}

.bmc-canvas__partnership {
  grid-column: 1;
  grid-row: 1/3;
}
.bmc-canvas__activities {
  grid-column: 2;
  grid-row: 1;
}
.bmc-canvas__resources {
  grid-column: 2;
  grid-row: 2;
}
.bmc-canvas__value {
  grid-column: 3;
  grid-row: 1/3;
}
.bmc-canvas__customer-relations {
  grid-column: 4;
  grid-row: 1;
}
.bmc-canvas__channels {
  grid-column: 4;
  grid-row: 2;
}
.bmc-canvas__customer-segments {
  grid-column: 5;
  grid-row: 1/3;
}

@media (max-width: 1100px) {
  .bmc-canvas {
    overflow: auto;
    .bmc-canvas__top,
    .bmc-canvas__bottom {
      display: flex;
      flex-wrap: wrap;
      height: auto;
    }
    .bmc-canvas__item {
      flex: 1;
      min-height: 250px;
    }
  }
}

@media (max-width: 768px) {
  .bmc-toolbar {
    padding: 0 10px;
    .bmc-toolbar__buttons {
      margin-left: 10px;
      button {
        padding: 0;
        max-width: 35px;
        max-height: 35px;
      }
    }
  }
}

@media print {
}
</style>



// WEBPACK FOOTER //
// src/components/Canvas.vue